import { fromJS } from 'immutable';
import { message } from 'antd';

// Actions
import { onInvitationAccepted } from '../app/actions';

// Selectors
import {
    getAddOrEditMeterModalIsLoading,
    getAddOrEditDeviceModalIsLoading,
    getHomeOwnersListIsLoading, getAddOrEditSwitchModalIsLoading
} from './selectors';
import { selectedLangageSelector } from '../app/selector';

// Constants
import { CONSTANTS } from './constants';
import { api, METHOD, REQUEST_URL, formatPattern, INVITATION_HASH_ID_ROUTE_PARAM } from '../../utils';
import { strings } from '../../localization';

const onHomesAreLoading = isLoading => ({
    type: CONSTANTS.ON_HOMES_ARE_LOADING,
    payload: { isLoading }
});

const onHomesList = data => ({
    type: CONSTANTS.ON_HOMES_LIST,
    payload: { data }
});

const onAdminHomesAreLoading = isLoading => ({
    type: CONSTANTS.ON_ADMIN_HOMES_ARE_LOADING,
    payload: { isLoading }
});

const onAdminHomesList = data => ({
    type: CONSTANTS.ON_ADMIN_HOMES_LIST,
    payload: { data }
});

const onHomeDetailIsLoading = isLoading => ({
    type: CONSTANTS.ON_HOME_DETAIL_IS_LOADING,
    payload: { isLoading }
});

const onHomeDetailData = data => ({
    type: CONSTANTS.ON_HOME_DETAIL_DATA,
    payload: { data }
});

const onHomeDetailUserListIsLoading = isLoading => ({
    type: CONSTANTS.ON_HOME_USER_LIST_IS_LOADING,
    payload: { isLoading }
});

const onHomeDetailUserListData = data => ({
    type: CONSTANTS.ON_HOME_USER_LIST_DATA,
    payload: { data }
});

export const onAddOrEditModalIsShown = isShown => ({
    type: CONSTANTS.ON_HOME_ADD_OR_EDIT_MODAL_IS_SHOWN,
    payload: { isShown }
});

const onAddOrEditModalIsLoading = isLoading => ({
    type: CONSTANTS.ON_HOME_ADD_OR_EDIT_MODAL_IS_LOADING,
    payload: { isLoading }
});

export const onAddOrEditModalIsEdit = isEdit => ({
    type: CONSTANTS.ON_HOME_ADD_OR_EDIT_MODAL_IS_EDIT,
    payload: { isEdit }
});

export const onAddOrEditModalSelectedRow = record => ({
    type: CONSTANTS.ON_HOME_ADD_OR_EDIT_MODAL_SELECTED_ROW,
    payload: {
        record: record ? fromJS(record) : null
    }
});

const onInvitedUsersList = data => ({
    type: CONSTANTS.ON_HOME_DETAIL_INVITED_USERS_LIST,
    payload: { data }
});

const onInvitedUsersAreLoading = isLoading => ({
    type: CONSTANTS.ON_HOME_DETAIL_INVITED_USERS_IS_LOADING,
    payload: { isLoading }
});

export const onInviteNewResidentModalIsShown = isShown => ({
    type: CONSTANTS.ON_HOME_INVITE_RESIDENT_MODAL_IS_SHOWN,
    payload: { isShown }
});

const onInviteNewResidentModalIsLoading = isLoading => ({
    type: CONSTANTS.ON_HOME_INVITE_RESIDENT_MODAL_IS_LOADING,
    payload: { isLoading }
});

const onAllUsersIsLoading = isLoading => ({
    type: CONSTANTS.ON_ADMIN_USERS_ARE_LOADING,
    payload: { isLoading }
});

const onAllUsersList = data => ({
    type: CONSTANTS.ON_ADMIN_USERS_LIST,
    payload: { data }
});

const onHomeDetaiLMetersAreLoading = isLoading => ({
    type: CONSTANTS.ON_HOME_DETAIL_METERS_IS_LOADING,
    payload: { isLoading }
});

const onHomeDetaiLMetersData = data => ({
    type: CONSTANTS.ON_HOME_DETAIL_METERS_DATA,
    payload: { data }
});

export const onAddOrEditMeterModalIsLoading = isLoading => ({
    type: CONSTANTS.ON_HOME_DETAIL_METERS_ADD_OR_EDIT_MODAL_IS_LOADING,
    payload: { isLoading }
});

export const onAddOrEditSwitchModalIsShown = isShown => ({
    type: CONSTANTS.ON_HOME_DETAIL_SWITCH_ADD_OR_EDIT_MODAL_IS_SHOWN,
    payload: { isShown }
});

export const onAddOrEditSwitchModalIsLoading = isLoading => ({
    type: CONSTANTS.ON_HOME_DETAIL_SWITCH_ADD_OR_EDIT_MODAL_IS_LOADING,
    payload: { isLoading }
});

const onHomeDetailMeterDeviceIsLoading = (index, isLoading) => ({
    type: CONSTANTS.ON_HOME_DETAIL_METER_DEVICE_IS_LOADING,
    payload: { index, isLoading }
});

const onHomeDetailMeterDeviceData = (index, data) => ({
    type: CONSTANTS.ON_HOME_DETAIL_METER_DEVICE_DATA,
    payload: { index, data }
});

export const onAddOrEditDeviceModalIsShown = isShown => ({
    type: CONSTANTS.ON_HOME_DETAIL_ADD_OR_EDIT_DEVICE_MODAL_IS_SHOWN,
    payload: { isShown }
});

export const onAddOrEditDeviceModalIsLoading = isLoading => ({
    type: CONSTANTS.ON_HOME_DETAIL_ADD_OR_EDIT_DEVICE_MODAL_IS_LOADING,
    payload: { isLoading }
});

export const onOwnerListIsLoading = isLoading => ({
    type: CONSTANTS.ON_OWNER_LIST_IS_LOADING,
    payload: { isLoading }
});
export const onOwnerList = data => ({
    type: CONSTANTS.ON_OWNER_LIST_DATA,
    payload: { data }
});

export const onTestSmartPiChangeSwitches = data => ({
    type: CONSTANTS.ON_TEST_SMART_PI_CHANGE_SWITCHES,
    payload: { data }
});

export const onSearchHomes = searchHomeFields => ({
    type: CONSTANTS.ON_ADMIN_SEARCH_HOMES,
    payload: {searchHomeFields }
});

export const onSearchUsers = searchUserFields => ({
    type: CONSTANTS.ON_ADMIN_SEARCH_USERS,
    payload: { searchUserFields }
});

// ========= THUNKS ============

/**
 * onSetSmartPiSwitches
 * - Set smart pi 8 switches
 * @see SmartPi.js
 * @since 1.8.0
 *
 *
 * @param String bitSequence
 */
export const onSetSmartPiSwitches = (bitSequence, dispatch, deviceId = 1) =>
    api(
        `${formatPattern(REQUEST_URL.SMART_PI, { devId: deviceId })}?bitSequence=${bitSequence}`,
        METHOD.POST,
        {}
    ).then(res => {
        dispatch(res.body);
    });

export const onSetSmartPiSolar = (command, dispatch, deviceId = 1) =>
    api(
        `${formatPattern(REQUEST_URL.SMART_PI_SOLAR, { devId: deviceId })}?command=${command}`,
        METHOD.POST,
        {}
    ).then(res => {
        dispatch(res.body);
    });

/**
 * onGetSmartPiSwitches
 * - Get smart pi 8 switches
 * @see SmartPi.js
 * @since 1.8.0
 */
export const onGetSmartPiSwitches = (dispatch, deviceId = 1) =>
    api(`${formatPattern(REQUEST_URL.SMART_PI, { devId: deviceId })}`, METHOD.GET, {}).then(res => {
        dispatch(res.body);
    }).catch(()=>{
        dispatch(null);
    });

/**
 * fetchAllHomes
 * - Fetching all homes connected to currently logged user
 * @since 0.2.0
 *
 *
 * @returns {Promise}
 */
export const fetchAllHomes = () => (dispatch, getState) => {
    const homesState = getState().homes.get('list');

    if (homesState.get('isLoading')) return;

    dispatch(onHomesAreLoading(true));

    return api(`${REQUEST_URL.HOMES_LIST}?page=0&size=100`,
        METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onHomesList(fromJS(res.body.content)));
                dispatch(onHomesAreLoading(false));
            }
        })
        .catch(err => {
            dispatch(onHomesAreLoading(false));
            throw err;
        });
};

/**
 * fetchHomeDetail
 * - Fetching current detail based on URL param
 * @since 0.2.0
 *
 *
 * @param {object} params
 * @param {number} loadPage
 * @param {number} pageSize
 * @param {string} meterId
 *
 * @param name
 * @param email
 * @returns {Promise}
 */
export const fetchAdminHomes = (params, loadPage = 0, pageSize = 10, meterId = '', name = '', email = '', company = '') => (dispatch, getState) => {
    const homesState = getState().homes.getIn(['administration', 'homes']);
    const showDeleted = getState().app.get('showDeletedRecords') || false;

    if (homesState.get('isLoading')) return;

    dispatch(onAdminHomesAreLoading(true));

    return api(`${REQUEST_URL.HOMES_LIST}?page=${loadPage}&size=${pageSize}&sort=name,asc&meter=${meterId}&name=${name}&email=${email}&company=${company}&deleted=${showDeleted}`, METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onAdminHomesList(fromJS(res.body)));
                dispatch(onAdminHomesAreLoading(false));
            }
        })
        .catch(err => {
            dispatch(onAdminHomesAreLoading(false));
            throw err;
        });
};

/**
 * fetchHomeDetail
 * - Fetching current detail based on URL param
 * @since 0.2.0
 *
 *
 * @param {object} params
 *
 * @returns {Promise}
 */
export const fetchHomeDetail = params => (dispatch, getState) => {
    const homeDetailState = getState().homes.get('detail');

    if (homeDetailState.get('isLoading')) return;

    dispatch(onHomeDetailIsLoading(true));

    return api(formatPattern(REQUEST_URL.HOME_DETAIL, params), METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onHomeDetailData(fromJS(res.body)));
                dispatch(onHomeDetailIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onHomeDetailIsLoading(false));
            throw err;
        });
};

/**
 * fetchHomeDetailMeters
 * - Fetching meters for current detail
 * @since 0.2.0
 *
 *
 * @param {object} params
 *
 * @returns {Promise}
 */
export const fetchHomeDetailMeters = params => (dispatch, getState) => {
    const homeDetailMetersState = getState().homes.getIn(['detail', 'meters']);
    const showDeleted = getState().app.get('showDeletedRecords') || false;

    if (homeDetailMetersState.get('isLoading')) return;

    dispatch(onHomeDetaiLMetersAreLoading(true));

    return api(`${formatPattern(REQUEST_URL.METER_LIST, params)}?deleted=${showDeleted}`, METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                const body = res.body.map(meter => ({
                    ...meter,
                    devices: { isLoading: true, data: [] }
                }));

                dispatch(onHomeDetaiLMetersData(fromJS(body)));
                dispatch(onHomeDetaiLMetersAreLoading(false));
            }
        })
        .catch(err => {
            dispatch(onHomeDetaiLMetersAreLoading(false));
            throw err;
        });
};

export const onAddNewMeter = (values, params) => (dispatch, getState) => {
    const isLoading = getAddOrEditMeterModalIsLoading(getState());
    if (isLoading || !values) return;

    return api(formatPattern(REQUEST_URL.HOME_DETAIL_METER, params), METHOD.POST, values)
        .then(res => {
            if (res && res.ok) {
                dispatch(onAddOrEditMeterModalIsLoading(false));
                dispatch(fetchHomeDetailMeters(params));
            }
        })
        .catch(err => {
            dispatch(onAddOrEditMeterModalIsLoading(false));
            throw err;
        });
};

export const onEditMeter = (recordToEdit, values, params) => (dispatch, getState) => {
    const isLoading = getAddOrEditMeterModalIsLoading(getState());
    if (isLoading || !values) return;

    return api(
        formatPattern(REQUEST_URL.METER_ID, {
            meterId: recordToEdit.meter
        }),
        METHOD.PATCH,
        values
    )
        .then(res => {
            if (res && res.ok) {
                dispatch(onAddOrEditMeterModalIsLoading(false));
                dispatch(fetchHomeDetailMeters(params));
            }
        })
        .catch(err => {
            dispatch(onAddOrEditMeterModalIsLoading(false));
            throw err;
        });
};

export const onDeleteMeter = meterId => () =>
    api(
        formatPattern(REQUEST_URL.METER_ID, {
            meterId
        }),
        METHOD.DELETE
    );

export const onUndeleteMeter = meterId => () =>
    api(
        formatPattern(REQUEST_URL.METER_ID_UNDELETE, {
            meterId
        }),
        METHOD.PUT
    );

export const onAddNewSwitch = (values, params) => (dispatch, getState) => {
    const isLoading = getAddOrEditSwitchModalIsLoading(getState());
    if (isLoading || !values) return;

    return api(formatPattern(REQUEST_URL.HOME_DETAIL_METER_SWITCH, params), METHOD.POST, values)
        .then(res => {
            if (res && res.ok) {
                dispatch(onAddOrEditSwitchModalIsLoading(false));
                dispatch(onAddOrEditSwitchModalIsShown(false));
            }
        })
        .catch(err => {
            dispatch(onAddOrEditSwitchModalIsLoading(false));
            throw err;
        });
};

export const onEditSwitch = (values, params) => (dispatch, getState) => {
    const isLoading = getAddOrEditSwitchModalIsLoading(getState());
    if (isLoading || !values) return;

    return api(
        formatPattern(REQUEST_URL.SWITCH_UPDATE, {
            meterId: params.meterId,
            switchId: values.switch,
        }),
        METHOD.PUT,
        values
    )
        .then(res => {
            if (res && res.ok) {
                dispatch(onAddOrEditSwitchModalIsLoading(false));
                dispatch(onAddOrEditSwitchModalIsShown(false));
            }
        })
        .catch(err => {
            dispatch(onAddOrEditSwitchModalIsLoading(false));
            throw err;
        });
};

export const fetchDeviceForMeter = meterId => (dispatch, getState) => {
    const homeDetailMetersState = getState().homes.getIn(['detail', 'meters']);
    const showDeleted = getState().app.get('showDeletedRecords') || false;

    if (homeDetailMetersState.get('isLoading')) return;

    const currentMeterIndex = homeDetailMetersState
        .get('data')
        .findIndex(meter => meter.get('meter') === meterId);

    if (currentMeterIndex === -1) return;

    dispatch(onHomeDetailMeterDeviceIsLoading(currentMeterIndex, true));
    return api(
        `${formatPattern(REQUEST_URL.DEVICE_FOR_METER_ID, {
            meterId
        })}?deleted=${showDeleted}`,
        METHOD.GET
    )
        .then(res => {
            // console.log(res.body);
            if (res && res.ok) {
                dispatch(onHomeDetailMeterDeviceIsLoading(currentMeterIndex, false));
                dispatch(onHomeDetailMeterDeviceData(currentMeterIndex, fromJS(res.body)));
            }
        })
        .catch(err => {
            dispatch(onHomeDetailMeterDeviceIsLoading(currentMeterIndex, false));
            throw err;
        });
};

export const onAddNewDeviceForMeter = (meterId, values, params) => (dispatch, getState) => {
    const isLoading = getAddOrEditDeviceModalIsLoading(getState());
    if (isLoading || !values) return;
    dispatch(onAddOrEditDeviceModalIsLoading(true));
    return api(
        `${formatPattern(REQUEST_URL.HOME_DETAIL_METER_DEVICE, {
            ...params,
            meterId
        })}?typeId=${values.type}`,
        METHOD.POST,
        values
    )
        .then(res => {
            if (res && res.ok) {
                dispatch(onAddOrEditDeviceModalIsLoading(false));
                dispatch(onAddOrEditDeviceModalIsShown(false));
                dispatch(fetchDeviceForMeter(meterId));
            }
        })
        .catch(err => {
            dispatch(onAddOrEditDeviceModalIsLoading(false));
            throw err;
        });
};

export const onEditDeviceForMeter = (meterId, deviceId, values) => (dispatch, getState) => {
    const isLoading = getAddOrEditDeviceModalIsLoading(getState());
    if (isLoading || !values) return;

    dispatch(onAddOrEditDeviceModalIsLoading(true));
    return api(
        `${formatPattern(REQUEST_URL.DEVICE_ID, {
            deviceId
        })}?typeId=${values.type}`,
        METHOD.PATCH,
        values
    )
        .then(res => {
            if (res && res.ok) {
                dispatch(onAddOrEditDeviceModalIsLoading(false));
                dispatch(onAddOrEditDeviceModalIsShown(false));
                dispatch(fetchDeviceForMeter(meterId));
            }
        })
        .catch(err => {
            dispatch(onAddOrEditDeviceModalIsLoading(false));
            throw err;
        });
};

export const onDeleteDeviceForMeter = deviceId => () =>
    api(
        formatPattern(REQUEST_URL.DEVICE_ID, {
            deviceId
        }),
        METHOD.DELETE
    );

export const onUndeleteDeviceForMeter = deviceId => () =>
    api(
        formatPattern(REQUEST_URL.DEVICE_ID_UNDELETE, {
            deviceId
        }),
        METHOD.PUT
    );
/**
 * fetchInvitedUsers
 * - Fetching invited users for currently loaded home
 * @since 0.4.0
 *
 *
 * @param {object} params
 *
 * @returns {Promise}
 */
export const fetchInvitedUsers = params => (dispatch, getState) => {
    const homeDetailState = getState().homes.get('detail');

    if (homeDetailState.getIn(['users', 'invitedUsers', 'isLoading'])) return;

    dispatch(onInvitedUsersAreLoading(true));

    return api(formatPattern(REQUEST_URL.HOME_DETAIL_INVITED_USERS, params), METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onInvitedUsersList(fromJS(res.body)));
                dispatch(onInvitedUsersAreLoading(false));
            }
        })
        .catch(err => {
            dispatch(onInvitedUsersAreLoading(false));
            throw err;
        });
};

/**
 * handleDeleteInvitedUser
 * - Deleting invitation for user with email
 * @since 0.4.0
 *
 *
 * @param {number} invitationId
 *
 * @returns {Promise}
 */
export const handleDeleteInvitedUser = invitationId => () =>
    api(
        formatPattern(REQUEST_URL.INVITATION_ID, {
            invitationId
        }),
        METHOD.DELETE
    );

/**
 * fetchHomeDetailUserList
 * - Fetching current detail based on URL param
 * @since 0.2.0
 *
 *
 * @param {object} params
 */
export const fetchHomeDetailUserList = params => (dispatch, getState) => {
    const homeDetailUsersState = getState().homes.getIn(['detail', 'users']);

    if (homeDetailUsersState.get('isLoading') || !params) return;

    dispatch(onHomeDetailUserListIsLoading(true));

    return api(formatPattern(REQUEST_URL.HOME_DETAIL_USERS, params), METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onHomeDetailUserListData(fromJS(res.body)));
                dispatch(onHomeDetailUserListIsLoading(false));
            }
        })
        .catch(() => {
            dispatch(onHomeDetailUserListIsLoading(false));
        });
};

/**
 * onAddNewHome
 * - Adding new home via AddOrEditHomeModal
 * @see AddOrEditHomeModal.js
 * @since 0.2.0
 *
 *
 * @param {object} values
 */
export const onAddNewHome = (values, isUsedInAdmin = false) => (dispatch, getState) => {
    dispatch(onAddOrEditModalIsLoading(true));
    // TODO: do something with values
    return api(`${REQUEST_URL.HOME}?lang=${selectedLangageSelector(getState())}`, METHOD.POST, {
        ...values
    })
        .then(res => {
            if (res && res.ok) {
                dispatch(onAddOrEditModalIsLoading(false));
                dispatch(onAddOrEditModalIsShown(false));
                if (isUsedInAdmin) {
                    dispatch(fetchAdminHomes());
                } else {
                    dispatch(fetchAllHomes());
                }
            }
        })
        .catch(err => {
            dispatch(onAddOrEditModalIsLoading(false));
            dispatch(onAddOrEditModalIsShown(false));
            throw err;
        });
};

/**
 * onEditHome
 * - Editing existing home via AddOrEditHomeModal
 * @see AddOrEditHomeModal.js
 * @since 0.3.0
 *
 * @param {number} homeId
 * @param {object} values
 */
export const onEditHome = (homeId, values, isUsedInAdmin = false) => (dispatch, getState) => {
    dispatch(onAddOrEditModalIsLoading(true));
    return api(
        `${formatPattern(REQUEST_URL.HOME_ID, {
            homeId
        })}?lang=${selectedLangageSelector(getState())}`,
        METHOD.PATCH,
        {
            ...values
        }
    )
        .then(res => {
            if (res && res.ok) {
                dispatch(onAddOrEditModalIsLoading(false));
                dispatch(onAddOrEditModalIsShown(false));
                dispatch(onAddOrEditModalIsEdit(false));
                dispatch(onAddOrEditModalSelectedRow(null));
                if (isUsedInAdmin) {
                    dispatch(fetchAdminHomes());
                } else {
                    dispatch(fetchAllHomes());
                }
            }
        })
        .catch(err => {
            dispatch(onAddOrEditModalIsLoading(false));
            dispatch(onAddOrEditModalIsEdit(false));
            dispatch(onAddOrEditModalSelectedRow(null));
            dispatch(onAddOrEditModalIsShown(false));
            throw err;
        });
};

/**
 * handleDeleteHome
 * - Deleting existing home
 * @see homes/index.js
 * @since 0.3.0
 *
 *
 * @param {number} homeId
 * @param {object} params
 */
export const handleDeleteHome = (homeId, params) => () =>
    api(
        formatPattern(REQUEST_URL.HOME_ID, {
            ...params,
            homeId
        }),
        METHOD.DELETE
    );

/**
 * handleUndeleteHome
 * - Undeleting deleted home
 * @see administration/AllHomesTab.js
 * @since 0.3.0
 *
 *
 * @param {number} homeId
 * @param {object} params
 */
export const handleUndeleteHome = (homeId, params) => () =>
    api(
        formatPattern(REQUEST_URL.HOME_UNDELETE_ID, {
            ...params,
            homeId
        }),
        METHOD.PUT
    );

export const handleDeleteUser = (userIdToDelete, params) => () =>
    api(
        formatPattern(REQUEST_URL.HOME_DETAIL_USER_ID, {
            ...params,
            residentId: userIdToDelete
        }),
        METHOD.DELETE
    );

export const handleAdminDeleteUser = (userIdToDelete, params) => () =>
    api(
        formatPattern(REQUEST_URL.USER_ID, {
            ...params,
            userId: userIdToDelete
        }),
        METHOD.DELETE
    );

export const handleAdminUndeleteUser = (userIdToUndelete, params) => () =>
    api(
        formatPattern(REQUEST_URL.USER_ID_UNDELETE, {
            ...params,
            userId: userIdToUndelete
        }),
        METHOD.PUT
    );

/**
 * handleAdminEditUser
 * - Editing user within administration
 * @since 0.4.0
 *
 *
 * @param {object} values
 * @param {number} userId
 */
export const handleAdminEditUser = (values, userId) => () => {
    console.log('values', values, ' param s', userId);

    return api(
        formatPattern(REQUEST_URL.USER_ID, {
            userId
        }),
        METHOD.PATCH,
        values
    );
};

/**
 * onInviteNewResident
 * - Processing invitation
 * @see home/detail/InviteUserModal.js
 * @since 0.3.0
 *
 *
 * @param {string} email
 * @param {object} params
 */
export const onInviteNewResident = (email, params) => (dispatch, getState) => {
    const inviteModalState = getState().homes.getIn(['detail', 'users', 'inviteModal']);
    if (inviteModalState.get('isLoading')) return Promise((resolve, reject) => reject());

    dispatch(onInviteNewResidentModalIsLoading(true));
    return api(
        `${formatPattern(REQUEST_URL.HOME_DETAIL_INVITE_RESIDENT, {
            ...params
        })}?lang=${selectedLangageSelector(getState())}`,
        METHOD.PATCH,
        {
            email
        }
    )
        .then(() => {
            dispatch(onInviteNewResidentModalIsLoading(false));
            dispatch(onInviteNewResidentModalIsShown(false));
            dispatch(fetchInvitedUsers(params));
            message.success(strings.homes.invitationSuccesfullySent, 2);
        })
        .catch(err => {
            dispatch(onInviteNewResidentModalIsLoading(false));
            dispatch(onInviteNewResidentModalIsShown(false));
            throw err;
        });
};

/**
 * processInvitationLink
 * - Processing invitation
 * @see invitation/index.js
 * @since 0.3.0
 *
 *
 * @param {object} params
 */
export const processInvitationLink = (params, isOwnerInvitation) => dispatch => {
    console.log('processInvitationLink / params', params, 'isOwner invitation', isOwnerInvitation);
    return api(
        formatPattern(
            isOwnerInvitation ? REQUEST_URL.INVITATION_OWNER_PROCESS : REQUEST_URL.INVITATION_PROCESS,
            {
                [INVITATION_HASH_ID_ROUTE_PARAM]: params[INVITATION_HASH_ID_ROUTE_PARAM]
            }
        ),
        METHOD.PUT
    ).then(() => {
        dispatch(onInvitationAccepted('success'));
        message.success(strings.homes.acceptInvitationSuccess, 10);
    })
    .catch(error => {
        dispatch(onInvitationAccepted('error'));
        throw error;
    });
};

/**
 * fetchAdminUsers
 * - Fetching all users for administration
 * @see administration/AllUsersTab.js
 * @since 0.4.0
 *
 *
 * @param {number} loadPage
 * @param {number} pageSize
 */
export const fetchAdminUsers = (loadPage = 0, pageSize = 10, name = '', email = '',  company = '') => (dispatch, getState) => {
    const adminUsersState = getState().homes.getIn(['administration', 'users']);
    const showDeleted = getState().app.get('showDeletedRecords') || false;

    if (adminUsersState.get('isLoading')) return;

    dispatch(onAllUsersIsLoading(true));

    return api(`${REQUEST_URL.USER_ADMIN}?page=${loadPage}&size=${pageSize}&sort=name,desc&deleted=${showDeleted}&name=${name}&email=${email}&company=${company}`, METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onAllUsersList(fromJS(res.body)));
                dispatch(onAllUsersIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onAllUsersIsLoading(false));
            throw err;
        });
};

/**
 * fetchOwnerList
 * - Fetching all undeleted users with possible query for email
 * @see homes/AddOrEditHomeModal.js
 * @since 0.5.0
 *
 *
 * @param {string} emailSearch
 * @returns {Promise}
 */
export const fetchOwnerList = emailSearch => (dispatch, getState) => {
    const ownerListIsLoading = getHomeOwnersListIsLoading(getState());

    if (ownerListIsLoading) return;
    dispatch(onOwnerListIsLoading(true));

    return api(`${REQUEST_URL.USER_FILTER}${emailSearch ? `?email=${emailSearch}` : ''}`, METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onOwnerList(fromJS(res.body)));
                dispatch(onOwnerListIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onOwnerListIsLoading(false));
            throw err;
        });
};
